/**
 * example
 * <base-button-icon on-click="onClick()" icon-name="add-outline" size="s"></base-button-icon>
 */
angular.module('inspinia').directive('baseButtonIcon', () => {
  return {
    restrict: 'E',
    scope: {
      text: '@',
      type: '@',
      ngDisabled: '=?',
      size: '@',
      onClick: '&',
      iconName: '@',
      baseButtonIconClasses: '&',
    },
    templateUrl: '/manage/src/view/directive/button/base_button_icon.html' + '?' + new Date().getTime(),
    link: function ($scope, _element, _attrs, _ctrl) {
      $scope.ngDisabled = $scope.ngDisabled || false;

      var buttonSize = ['xs', 's', 'r'];
      $scope.size = $scope.size || 'r';
      if (buttonSize.indexOf($scope.size) === -1) {
        throw new Error('button size is xs,s,r');
      }

      const buttonType = ['primary', 'secondary', 'alert'];
      $scope.type = $scope.type || 'primary';
      if (buttonType.indexOf($scope.type) === -1) {
        throw new Error('button type is primary,secondary,alert');
      }
      if (!$scope.iconName) {
        throw new Error('iconName is required');
      }

      $scope.onClickBaseButton = () => {
        // 無効の場合、クリックイベントは発火させない
        if (!$scope.ngDisabled) $scope.onClick();
      };

      /** CSSのクラス名を返す */
      $scope.baseButtonIconClasses = () => {
        const buttonIconClasses = {};
        if ($scope.ngDisabled) {
          buttonIconClasses['anglrC-buttonIcon--disabled'] = true;
        } else {
          buttonIconClasses['anglrC-buttonIcon--' + $scope.type] = true;
        }
        buttonIconClasses['anglrC-buttonIcon--' + $scope.size] = true;
        return buttonIconClasses;
      };
    },
  };
});
